import { render, staticRenderFns } from "./RevisaoInterna.vue?vue&type=template&id=7ab035a1&scoped=true"
import script from "./RevisaoInterna.vue?vue&type=script&lang=js"
export * from "./RevisaoInterna.vue?vue&type=script&lang=js"
import style0 from "./RevisaoInterna.vue?vue&type=style&index=0&id=7ab035a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab035a1",
  null
  
)

export default component.exports